export const STEERING_YEAR = 'steeringYear'
export const IS_NEW_MEETING_NAVIGATION = 'newMeetingNavigation'
